import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationModule } from 'src/core-lib/navigation/navigation.module';
import { PipeModule } from 'src/core-lib/pipes/pipe.module';
import { UmbracoImage } from 'src/core-lib/umbraco/umbraco-image.model';
import { VarModule } from 'src/core-lib/var/var.module';
import { TagManagerModule } from 'src/externals/tag-manager/tag-manager.module';
import { GridModule } from 'src/layout/grid/grid.module';
import { MediaModule } from 'src/layout/media/media.module';
import { StorageUtil } from 'src/utils/storage.util';
import { FooterBedrockComponent } from './components/footer-bedrock/footer-bedrock.component';
import { FooterCardsComponent } from './components/footer-cards/footer-cards.component';
import { FooterContactComponent } from './components/footer-contact/footer-contact.component';
import { FooterCountrySelectorComponent } from './components/footer-country-selector/footer-country-selector.component';
import { FooterHoursOfOperationsComponent } from './components/footer-hours-of-operations/footer-hours-of-operations.component';
import { FooterLicensesComponent } from './components/footer-licenses/footer-licenses.component';
import { FooterMediasComponent } from './components/footer-medias/footer-medias.component';
import { FooterMenuComponent } from './components/footer-menu/footer-menu.component';
import { FooterSocialLinksComponent } from './components/footer-social-links/footer-social-links.component';
import { MenuConfiguration } from '../../models/main-configuration.model';
import { HeaderBasketButtonComponent } from '../header/components/header-basket-button/header-basket-button.component';
import { HeaderMenuComponent } from '../header/components/header-menu/header-menu.component';
import { HeaderSearchComponent } from '../header/components/header-search/header-search.component';
import { RecursiveLinkComponent } from '../header/components/recursive-link/recursive-link.component';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        TagManagerModule,
        CommonModule,
        MediaModule,
        NavigationModule,
        TranslateModule,
        ReactiveFormsModule,
        PipeModule,
        GridModule,
        VarModule,
        HeaderSearchComponent,
        HeaderBasketButtonComponent,
        HeaderMenuComponent,
        RecursiveLinkComponent,
        FooterBedrockComponent,
        FooterCardsComponent,
        FooterContactComponent,
        FooterCountrySelectorComponent,
        FooterHoursOfOperationsComponent,
        FooterLicensesComponent,
        FooterMediasComponent,
        FooterMenuComponent,
        FooterSocialLinksComponent,
    ]
})
export class FooterComponent {
    footerLogo: UmbracoImage = StorageUtil.get<MenuConfiguration>('menu').footerLogo;
    menu: Partial<MenuConfiguration> = StorageUtil.get<MenuConfiguration>('menu');
}
